import React from 'react';
import * as Icon from 'react-feather';
import { PixelCoin } from './cartoon/Art';
import { buyLink } from './cartoon/links';
import { useCommerce } from '../commerce/CommerceContext';

const vantagens = [
    { icon: <Icon.Truck size={20} />, texto: 'Frete grátis acima de R$ 99' },
    { icon: <Icon.MapPin size={20} />, texto: 'Entregamos em todo o Brasil' },
    { icon: <Icon.RefreshCw size={20} />, texto: 'Torra semanal, sempre fresquinho' },
];

export default function CTA() {
    // With the checkout enabled the purchase starts at the catalog, which feeds the cart.
    const { enabled } = useCommerce();
    const purchase = enabled
        ? { href: '#bitbean' }
        : { href: buyLink, target: '_blank', rel: 'noopener noreferrer' };

    return (
        <section className="lc lc-section bg-vermelho" id="comprar">
            <div className="lc-wrap lc-center">
                <span className="lc-pill">bora?</span>
                <h2 className="lc-title">Pronto pro primeiro gole<span className="lc-dot">?</span></h2>
                <p className="lc-text">
                    Peça o seu BitBean e descubra por que tanta gente está trocando o café de mercado pelo café especial.
                </p>
                <div className="lc-actions" style={{ justifyContent: 'center' }}>
                    <a {...purchase} className="lc-btn lc-btn-coin">
                        <PixelCoin /> Comprar agora
                    </a>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: '48px 0 0', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px 36px', fontSize: 16, fontWeight: 500 }}>
                    {vantagens.map((v) => (
                        <li key={v.texto} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <span aria-hidden="true">{v.icon}</span>{v.texto}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
